<template>
<b-form-group class="display-inline-block checkbox-ios" :label="label" :label-for="id">
  <label :for="id" class="switch form-control-label">
    <input :id="id" type="checkbox" class="ios form-check-input" :required="required" :value="false" v-model="localChecked" :disabled="inputDisabled">
    <i></i>
  </label>
</b-form-group>
</template>

<script>
export default {
  name: "IOSSwitch",
  props: {
    label: {
      default: "",
      type: String,
      required: false
    },
    id: {
      type: String,
      required: true
    },
    checked: {
      default: false,
      type: Boolean,
      required: false
    },
    required: {
      type: Boolean,
      default: false,
      required: false
    },
    inputDisabled: {
      type: Boolean,
      default: false,
      required: false
    }
  },
  computed: {
    localChecked: {
      get() {
        return this.checked
      },
      set(localChecked) {
        this.$emit('input', localChecked)
      }
    }
  }
}
</script>

<style src="./IOSSwitch.scss" lang="scss" scoped/>
